import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { CarsWaybillDialog } from '@ruby/shared/dialogs/unit-train/cars-waybilled/components/cars-waybill.dialog';
import { CarsWaybillContainer } from '@ruby/shared/dialogs/unit-train/cars-waybilled/containers/cars-waybill.container';

@NgModule({
  declarations: [CarsWaybillContainer, CarsWaybillDialog],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    MatDialogModule,
    NSGridModule
  ],
  exports: [CarsWaybillContainer]
})
export class CarsWaybillModule {}
